import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/events/future-of-freight/FutureOfFreight.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Events/FutureOfFreight/components/SectionHeader'));
const SectionArticles = dynamic(() => import('sections/Events/FutureOfFreight/components/SectionArticles'));
const SectionAgenda = dynamic(() => import('sections/Events/FutureOfFreight/components/SectionAgenda'));
const SectionSignUp = dynamic(() => import('sections/Events/FutureOfFreight/components/SectionSignUp'));

export default function FutureOfFreightPage() {
  return (
    <div className={cn('future-of-freight')}>
      <SectionHeader/>
      <SectionArticles/>
      <SectionAgenda/>
      <SectionSignUp/>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'The Future of Freight – Upcoming Event | DF Alliance',
      description:
        'Join DF Alliance\'s "Future of Freight" event to explore cutting-edge trends and innovations shaping the global logistics and freight forwarding landscape.',
      path: '/events/future-of-freight',
    },
  };
};

FutureOfFreightPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
